import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {
	Button,
	Checkbox,
	Divider,
	Form,
	Icon,
	Input,
	Message,
	Select,
	Popup
} from 'semantic-ui-react';

import {OPTION_FIRST_EMAIL_SENDOUT_DELAY, OPTION_SECOND_EMAIL_SENDOUT_DELAY, OPTION_THIRD_EMAIL_SENDOUT_DELAY} from '../../constants';

// Generic Components
import Alert from '../../components/alert';
import Loading from '../../components/loading';
import Tab from '../../components/tab';

import CheckBoxMessage from './components/check-box-message';

import Validator from '../../helpers/validator';
import GA from '../../helpers/ga';

import {
	getAbandonedCartTemplateConnections,
	updateTemplateConnections,
	updateSampleEmailRecipientEmail,
	sendSampleEmail,

	resetAlertMessage,
	reset,

	updateFormFieldForGeneralSettingsPage,
	getInProgressPayments
} from './actions';


const DEFAULT_STATE = {
	errorSampleEmailRecipientEmail: false,

	errorSettingsEmailSubject: false,
	errorSettingsColorButton: false,
	errorSettingsColorBackground: false,
	errorSettingsColorContainer: false,
	errorSettingsSenderEmailAddress: false,
	errorSettingsEmailSendoutDelay: false,

	buttonSendLoading: false,
	buttonUpdateLoading: false
};

const PAGE_VIEW_NAME = '/dashboard/emails/settings/general';

export class GeneralSettingsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = DEFAULT_STATE;
		this.props.getAbandonedCartTemplateConnections();
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillUnmount() {
		this.props.reset();
	}

	componentWillUpdate (nextProps, nextState) {
		if (this.refs.alert && nextProps.meta && _.get(nextProps, 'meta.message')) {
			this.refs.alert.show(nextProps.meta);
			this.props.resetAlertMessage();
			this.setState({
				buttonSendLoading: false,
				buttonUpdateLoading: false
			});
			return;
		}
	}

	componentWillReceiveProps (nextProps) {
		const {templateConnectionFirstEmail,templateConnectionSecondEmail,templateConnectionThirdEmail,payments} = nextProps;
		if (!templateConnectionFirstEmail || !templateConnectionSecondEmail || !templateConnectionThirdEmail) {
			nextProps.getAbandonedCartTemplateConnections();
			return;
		}
		if (!payments) {
			nextProps.getInProgressPayments();
			return;
		}
	}

	onSubmit = (e) => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'UpdateButton', 1);
		const {templateConnectionFirstEmail,templateConnectionSecondEmail,templateConnectionThirdEmail} = this.props;

		// Validation
		const errorSettingsSenderEmailAddress = ( Validator.emailRequired(this, templateConnectionFirstEmail, 'settings.sender_email_address', 'errorSettingsSenderEmailAddress'));
		if (
			errorSettingsSenderEmailAddress
		) {
			return;
		}

		this.setState({
			buttonUpdateLoading: true
		});

		// Set email to second and third template connection
		const senderEmailAddress = _.get(templateConnectionFirstEmail, 'settings.sender_email_address');
		_.set(templateConnectionSecondEmail, 'settings.sender_email_address', senderEmailAddress);
		_.set(templateConnectionThirdEmail, 'settings.sender_email_address', senderEmailAddress);

		// Save Template Connection
		const templateConnections = [templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail];
		this.props.updateTemplateConnections(templateConnections);
	}

	onClickSendSampleEmailButton = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'SendSampleEmailButton', 1);

		// Extract value from field
		const sampleEmailRecipientEmail = this.props.sampleEmailRecipientEmail;

		// Validation
		const errorSampleEmailRecipientEmail = Validator.emailRequired(this, this.props, 'sampleEmailRecipientEmail', 'errorSampleEmailRecipientEmail');
		if (
			errorSampleEmailRecipientEmail
		) {
			return;
		}

		this.setState({
			buttonSendLoading: true
		});
		this.props.sendSampleEmail(sampleEmailRecipientEmail);
	}

	onChangeTemplateConnectionFirstEmailField = (e, obj) => {
		this.onChangeField(e, obj, 'abandoned_cart');
	}

	onChangeTemplateConnectionSecondEmailField = (e, obj) => {
		this.onChangeField(e, obj, 'abandoned_cart_second_email');
	}

	onChangeTemplateConnectionThirdEmailField = (e, obj) => {
		this.onChangeField(e, obj, 'abandoned_cart_third_email');
	}

	onChangeField(e, obj, templateSlug) {
		const {templateConnectionFirstEmail,templateConnectionSecondEmail, templateConnectionThirdEmail} = this.props;
		if (obj.type === 'checkbox') {
			this.props.updateFormFieldForGeneralSettingsPage(templateSlug, templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail, obj.name, obj.checked);
			return;
		}
		this.props.updateFormFieldForGeneralSettingsPage(templateSlug, templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail, obj.name, obj.value);
	}

	onSampleEmailRecipientEmailChange = (e, obj) => {
		this.props.updateSampleEmailRecipientEmail(obj.value);
	}

	hasInProgressPayment(payments, productSlug) {
		const payment = _.find(payments, (o) => o.product_slug === productSlug);
		return !_.isNil(payment);
	}

	render() {
		const {templateConnectionFirstEmail,templateConnectionSecondEmail,templateConnectionThirdEmail,payments} = this.props;
		if (!templateConnectionFirstEmail || !templateConnectionSecondEmail || !templateConnectionThirdEmail || !payments) {
			return <Loading />;
		}
		const paneHeight = this.props.containerHeight - 70; // 70px is size of first row;
		const formGroupStyle = {marginTop: '20px'};
		const formFieldStyle = {paddingTop: '8px'};

		const isUsingWhiteLabel = this.hasInProgressPayment(payments, 'white_label');
		// const isUsingEmailPlus= this.hasInProgressPayment(payments, 'email_plus');

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Settings'
				subHeaderText='Configure abandoned cart email settings'
			>
				<Alert ref='alert'/>
				<Form>
					<Form.Group
						hidden={!isUsingWhiteLabel}
					>
						<Form.Field width='4'/>
						<Message
							as={Form.Field}
							width='8'
							color='yellow'
							style={{marginTop: '0px', marginLeft: '6px', paddingLeft: '20px'}}>
							<Message.Content>
								<p>Your emails will be sent out as "{_.get(templateConnectionFirstEmail, 'settings.sender_email_address', '')} via Chated.io".<br/>Complete "Domain Verification" if you want to remove "via Chated.io".</p>
							</Message.Content>
						</Message>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='From Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							name='settings.sender_email_address'
							placeholder='Email sender email address'
							value={ _.get(templateConnectionFirstEmail, 'settings.sender_email_address', '') }
							onChange={ this.onChangeTemplateConnectionFirstEmailField }
							error={ this.state.errorSettingsSenderEmailAddress }
						/>
						<Popup
							trigger={
								<Icon color='grey' name='info circle' size='large' style={{marginTop: '7px'}}/>
							}
							header='Reduce Bounce Rate Tips'
							content='Avoid using emails with the following domains: @gmail.com, @hotmail.com, @outlook.com, etc.'
							size='small'
						/>
					</Form.Group>
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='Test Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							width='6'
							control={ Input }
							placeholder='Email Address'
							onChange={ this.onSampleEmailRecipientEmailChange }
							error={ this.state.errorSampleEmailRecipientEmail }
						/>
						<Popup
							trigger={
								<Icon color='grey' name='info circle' size='large' style={{marginTop: '7px'}}/>
							}
							content='Remember to save your settings before getting sample emails'
							size='small'
						/>
						<Form.Field
							width='4'
							control={ Button }
							color='green'
							icon='send'
							content='Send'
							loading={ this.state.buttonSendLoading }
							onClick={ this.onClickSendSampleEmailButton }
						/>
					</Form.Group>
					<Divider />
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='1st Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							style={ formFieldStyle }
							control={ Checkbox }
							name='enabled'
							checked={ _.get(templateConnectionFirstEmail, 'enabled' ,false) }
							onChange={ this.onChangeTemplateConnectionFirstEmailField }
						/>
						<CheckBoxMessage isUsingEmailPlus={true} emailOrder={1}/>
					</Form.Group>
					<Form.Group
						style={ formGroupStyle }
					>
						<Form.Field
							width='4'
							label='Email Delay for 1st Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							disabled={ !_.get(templateConnectionFirstEmail, 'enabled' ,false) }
							width='6'
							control={ Select }
							name='settings.email_sendout_delay'
							options={ OPTION_FIRST_EMAIL_SENDOUT_DELAY }
							value={ _.get(templateConnectionFirstEmail, 'settings.email_sendout_delay', '') }
							onChange={ this.onChangeTemplateConnectionFirstEmailField }
							error={ this.state.errorSettingsEmailSendoutDelay }
						/>
					</Form.Group>
					<Divider />
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='2nd Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							style={ formFieldStyle }
							control={ Checkbox }
							name='enabled'
							checked={ _.get(templateConnectionSecondEmail, 'enabled' ,false) }
							onChange={ this.onChangeTemplateConnectionSecondEmailField }
						/>
						<CheckBoxMessage isUsingEmailPlus={true} emailOrder={2}/>
					</Form.Group>
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='Email Delay for 2nd Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							disabled={ !_.get(templateConnectionSecondEmail, 'enabled' ,false) }
							width='6'
							control={ Select }
							name='settings.email_sendout_delay'
							options={ OPTION_SECOND_EMAIL_SENDOUT_DELAY }
							value={ _.get(templateConnectionSecondEmail, 'settings.email_sendout_delay', '') }
							onChange={ this.onChangeTemplateConnectionSecondEmailField }
						/>
					</Form.Group>
					<Divider />
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='3rd Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							style={ formFieldStyle }
							control={ Checkbox }
							name='enabled'
							checked={ _.get(templateConnectionThirdEmail, 'enabled' ,false) }
							onChange={ this.onChangeTemplateConnectionThirdEmailField }
						/>
						<CheckBoxMessage isUsingEmailPlus={true} emailOrder={3}/>
					</Form.Group>
					<Form.Group style={ formGroupStyle }>
						<Form.Field
							width='4'
							label='Email Delay for 3rd Email'
							className='right'
							style={ formFieldStyle }
						/>
						<Form.Field
							disabled={ !_.get(templateConnectionThirdEmail, 'enabled' ,false) }
							width='6'
							control={ Select }
							name='settings.email_sendout_delay'
							options={ OPTION_THIRD_EMAIL_SENDOUT_DELAY }
							value={ _.get(templateConnectionThirdEmail, 'settings.email_sendout_delay', '') }
							onChange={ this.onChangeTemplateConnectionThirdEmailField }
						/>
					</Form.Group>
					<Form.Group style={ formGroupStyle } >
						<Form.Field width='4'/>
						<Form.Field
							width='6'
							control={ Button }
							color='blue'
							icon='save'
							content='SAVE'
							onClick={ this.onSubmit }
							loading={ this.state.buttonUpdateLoading }
						/>
					</Form.Group>
					<Form.Group style={{marginBottom: '200px'}} ></Form.Group>
				</Form>
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.dashboardEmailsSettingsReducer.meta,
		templateConnectionFirstEmail: state.dashboardEmailsSettingsReducer.templateConnectionFirstEmail,
		templateConnectionSecondEmail: state.dashboardEmailsSettingsReducer.templateConnectionSecondEmail,
		templateConnectionThirdEmail: state.dashboardEmailsSettingsReducer.templateConnectionThirdEmail,
		sampleEmailRecipientEmail: state.dashboardEmailsSettingsReducer.sampleEmailRecipientEmail,
		payments: state.dashboardEmailsSettingsReducer.payments
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getInProgressPayments () {
			dispatch( getInProgressPayments() );
		},

		updateTemplateConnections (templateConnections) {
			dispatch( updateTemplateConnections(templateConnections) );
		},

		getAbandonedCartTemplateConnections () {
			dispatch( getAbandonedCartTemplateConnections() );
		},

		updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) {
			dispatch( updateSampleEmailRecipientEmail(sampleEmailRecipientEmail) );
		},

		sendSampleEmail (recipientEmail) {
			dispatch( sendSampleEmail(recipientEmail) );
		},

		updateFormFieldForGeneralSettingsPage (templateSlug, templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail, fieldName, fieldValue) {
			dispatch( updateFormFieldForGeneralSettingsPage(templateSlug, templateConnectionFirstEmail, templateConnectionSecondEmail, templateConnectionThirdEmail, fieldName, fieldValue) );
		},

		resetAlertMessage () {
			dispatch( resetAlertMessage() );
		},

		reset() {
			dispatch( reset() );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(GeneralSettingsPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/general-settings-page.js